import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center paw-bg">
        <Loader2 className="w-8 h-8 animate-spin text-coral" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
